export default __webpack_public_path__ + "static/media/tick.5276ad7c.svg";